import { render, staticRenderFns } from "./PublishingInformation.vue?vue&type=template&id=a4e7be88"
import script from "./PublishingInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishingInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports